module.exports = __webpack_public_path__ + "img/CS-Hybrid_Overview-EVA_2.ad201637.jpg";